import {
  Form,
  Drawer,
  Input,
  Button,
  Checkbox,
  Radio,
  Collapse,
  Switch,
  InputNumber,
  Select,
  Tooltip,
  Cascader,
  Typography,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import { IconFont, BasTitle, SvgIcon, BasSwitch } from '@/components'
import { useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import {
  useEditSite,
  useGetDetail,
  useGetSiteArea,
  useGetSiteDeviceList,
  useGetSiteType,
} from '@/pages/waf/site-resource/utils'
import {
  useGetFingerprint,
  useEditSiteV1,
  useGetDetailV1,
  useGetCreateSiteSecurityDeviceList,
} from './utils'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { checkSiteName } from '@/api/waf-site'
import { V1AuthMode } from '@/api/waf-create-task'
import { t } from '@/i18n'

interface DeviceItem {
  name: string
  device_id: string
  device_list?: {
    device_type: string
    device_name: string
    device_ip: string
    name: string
    device_id: string
    disabled?: boolean
  }[]
  disabled?: boolean
}

const EditSiteModal = props => {
  const { onOk, onCancel, id, originFrom } = props
  console.log('originFrom', originFrom)
  const [form] = useForm()
  const { Option } = Select
  const { TextArea } = Input
  const { SHOW_CHILD } = Cascader
  const navigate = useNavigate()
  const [isConfig, setIsConfig] = useState(false)
  let [errorPage, setErrorPage] = useState(false)
  let [redirect, setRedirect] = useState(false)
  let [responseCode, setResponseCode] = useState(false)
  let [timeOut, setTimeOut] = useState(false)
  let [mode, setMode] = useState(1)
  let [method, setMethod] = useState('AuthModeNo')
  const [radioValue, setRadioValue] = useState<number>(2)
  let [componentId, setComponentId] = useState<string[]>([])
  let [deviceList, setDeviceList] = useState<{ device_id: string }[]>([])
  const [selectedDevices, setSelectedDevices] = useState<string[]>([])

  const [detail, getDetail] = useGetDetailV1() //站点详情
  const [getCreateSiteSecurityDeviceList] = useGetCreateSiteSecurityDeviceList()
  const [typeData, getSiteType, typeLoading] = useGetSiteType() // 设备厂商
  const [fingerprintData, getFingerprint, fingerprintLoading] = useGetFingerprint()
  const [getSiteArea, siteArea, siteLoading] = useGetSiteArea() // 安全域
  const [deviceData, setDeviceData] = useState([]) //站点级联
  const [editSite] = useEditSiteV1() // 编辑站点
  const [cookieSwitch, setCookieSwitch] = useState(false)
  const [cookieType, setCookieType] = useState('payload_frequency')

  let newComponentList = [{ name: t('全部'), id: '-1' }, ...(fingerprintData?.componentList || [])]

  useEffect(() => {
    getCreateSiteSecurityDeviceList()
      .then(res => {
        const group = res.data.groups.map(item => {
          if (item.devices.length > 0) {
            return {
              device_type: item?.deviceType?.name,
              device_list: item?.devices?.map(device => ({
                device_brand: device?.deviceBrand?.name,
                device_name: device?.deviceName,
                device_ip: device?.deviceIp,
                name: device?.deviceName,
                device_id: device?.id,
                chainId: device?.chainId,
              })),
            }
          }
        })

        console.log('group', group)

        setDeviceData(
          group
            .filter(
              item =>
                item !== undefined &&
                ['FW', 'WAF', 'IPS', 'NTA', 'IDS', 'NDR', 'SOC'].includes(item.device_type),
            )
            .map(item => ({ ...item })) || [],
        )
      })
      .catch(_ => {})
  }, [])

  useEffect(() => {
    getDetail({ id })
      .then(res => {
        let d = res.data
        console.log('d', d)
        setMethod(d.authMode)
        if (d?.cookieAuth == '') {
          setCookieSwitch(true)
        }
        setComponentId(d.component || [])
        if (d?.device?.length > 0) {
          console.log('d.device', d.device)
          for (const el of d.device) {
            el.name = `${el.deviceName}（${el.deviceIp}）`
          }
          setDeviceList(d.device)
          // 设置关联安全设备的选中状态
          const deviceIds = d.device?.map(i => i?.deviceId)
          setSelectedDevices(deviceIds || [])
          form.setFieldValue(
            'deviceIdList',
            d.device?.map(i => [i.deviceType, i?.deviceId]),
          )
        }
        // 设置验证默认设备
        if (d?.defaultVerifyDevice?.length > 0) {
          form.setFieldValue(
            'defaultVerifyDevice',
            d.defaultVerifyDevice?.map(i => [i.deviceType, i?.deviceId]),
          )
        }
        if (d.cookieRefreshFrequency?.cookieRefreshType === 'customizable_frequency') {
          setCookieType('customizable_frequency')
        }
        form.setFieldsValue({
          username: d.protocolAuth?.username,
          password: d.protocolAuth?.password,
          cookieRefreshSeconds: d?.cookieRefreshFrequency?.cookieRefreshSeconds || 10,
          cookieRefreshType: d?.cookieRefreshFrequency?.cookieRefreshType || 'payload_frequency',
          db: d.db.id,
          language: d.language.id,
          os: d.os.id,
          componentSwitch: d.componentSwitch === 2,
          authMode: d.authMode,
          areaId: d.areaId,
          remark: d.remark,
          autoUpdateFirm: d.autoUpdateFirm === 'SwitchStatusOn',
          site: d.site,
          siteName: d.siteName,
          component: d.component,
          cookieAuth: d.cookieAuth,
          wafDetectSwitch: d.wafDetectSwitch,
        })
      })
      .catch(_ => {})
  }, [])

  const preDeviceListData = data => {
    console.log('data', data)
    let arr: any[] = []
    for (const item of data) {
      let el = {
        name: item.device_type,
        device_id: item.device_type,
        device_list: item.device_list?.map(e => ({
          ...e,
          device_type: item.device_type,
          name: `${e.device_name}（${e.device_ip}）`,
        })),
      }
      arr.push(el)
    }
    console.log('arr', arr)
    return arr
  }

  const preVerifyDeviceListData = (data: any[], selectedDevices: string[]): DeviceItem[] => {
    // 获取当前选中的验证默认设备
    const currentSelectedDevices = form.getFieldValue('defaultVerifyDevice') || []
    // 获取第一个选中设备的 chainId
    const firstSelectedDevice = currentSelectedDevices[0]
    const firstSelectedDeviceId = firstSelectedDevice?.[1]

    // 从所有设备中查找第一个选中设备的完整信息
    let firstSelectedDeviceData = null
    for (const group of data) {
      if (group.device_list) {
        const device = group.device_list.find(d => d.device_id === firstSelectedDeviceId)
        if (device) {
          firstSelectedDeviceData = device
          break
        }
      }
    }
    const firstSelectedChainId = firstSelectedDeviceData?.chainId

    return data.map(item => {
      const deviceList = item.device_list?.map(device => {
        // 首先检查是否在关联安全设备中
        const isInSelectedDevices = selectedDevices.includes(device.device_id)

        // 如果有选中的设备，则检查 chainId 是否匹配
        let isChainIdMatch = true
        if (firstSelectedChainId && currentSelectedDevices.length > 0) {
          isChainIdMatch = device.chainId === firstSelectedChainId
        }

        return {
          ...device,
          device_type: item.device_type,
          name: `${device.device_name}（${device.device_ip}）`,
          disabled: !isInSelectedDevices || !isChainIdMatch,
        }
      })

      // 如果该分组下有任何可选设备，则该分组可选
      const hasEnabledDevice = deviceList?.some(device => !device.disabled)

      return {
        name: item.device_type,
        device_id: item.device_type,
        device_list: deviceList,
        disabled: !hasEnabledDevice,
      }
    })
  }

  const onDeviceSelect = (val, selectedOptions) => {
    let arr = selectedOptions?.map(el => el[1])
    setDeviceList(arr)
  }

  const onDeviceSelectChange = (value: any, selectedOptions) => {
    onDeviceSelect(value, selectedOptions)
    // 只保存具体设备ID，不包含设备类型
    const deviceIds = value.map((v: any[]) => v[1]).filter(Boolean)
    setSelectedDevices(deviceIds)
    // 当关联安全设备变化时，清空验证默认设备的选择
    form.setFieldValue('defaultVerifyDevice', [])
  }

  const checkedSiteName = (value: string, site_id) =>
    new Promise((resolve, reject) => {
      checkSiteName({ site_name: value, site_id })
        .then(res => {
          if (res.code === 200) {
            resolve(true)
          } else resolve(false)
        })
        .catch(error => {
          resolve(false)
        })
    })

  const submitHandler = value => {
    console.log('value', value)
    let o = {
      deviceIdList: mode === 3 ? deviceList?.map(item => item.deviceId) : undefined,
    }
    const obj = {
      // site: [form.getFieldValue('site')],
      // site: value.site?.map(item => ({
      //   url: item.site,
      //   name: item.site_name,
      // })),
      site: [{ url: form.getFieldValue('site'), name: value.siteName }],
      // siteName: value.siteName,
      // 设备配置
      ...o,
      // web认证
      authMode: method as V1AuthMode,
      protocolAuth: {
        username: method === 'AuthModeProtocolAuth' ? value.username : undefined,
        password: method === 'AuthModeProtocolAuth' ? value.password : undefined,
      },
      cookieAuth:
        method === 'AuthModeCookieAuth' ? (cookieSwitch ? '' : value.cookieAuth) : undefined,
      cookieRefreshFrequency: {
        cookieRefreshSeconds: value.cookieRefreshSeconds,
        cookieRefreshType: value.cookieRefreshType,
      },
      os: value.os,
      db: value.db,
      language: value.language,
      wafDetectSwitch: value.wafDetectSwitch,
      componentSwitch: value.componentSwitch ? 2 : 3,
      component: radioValue === 2 ? componentId?.filter(item => item !== '-1') : undefined,
      areaId: value.areaId,
      remark: value.remark,
      autoUpdateFirm: (value.autoUpdateFirm ? 'SwitchStatusOn' : 'SwitchStatusOff') as any,
      deviceIdList: value?.deviceIdList?.map(item => (typeof item === 'object' ? item[1] : item)),
      defaultVerifyDevice: value?.defaultVerifyDevice?.map(item =>
        typeof item === 'object' ? item[1] : item,
      ),
    }
    console.log(obj)
    editSite({ site: { ...obj }, id: id })
      .then(() => {
        onOk()
      })
      .catch(_ => {})
  }

  return (
    <DrawerBox
      width={760}
      onClose={() => {
        onCancel()
      }}
      open
      title={<BasTitle title={t('编辑站点')} />}
      bodyStyle={{ height: 'calc(100vh - 108px)', overflow: 'scroll' }}
      maskClosable={false}
      destroyOnClose
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={() => onCancel()} style={{ marginRight: 8 }}>
            {t('取消')}
          </Button>
          <Button type="primary" onClick={form.submit}>
            {t('确定')}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        onFinish={submitHandler}
        layout={'horizontal'}
        initialValues={{}}
        colon={false}
      >
        <ContentBox>
          <div style={{ marginBottom: 24 }}>
            <span style={{ width: 113, display: 'inline-block' }}>{t('站点：')}</span>
            <Typography.Text
              ellipsis={{
                tooltip: {
                  getPopupContainer: () => document.body,
                },
              }}
              style={{ width: 450 }}
            >
              {form.getFieldValue('site')}
            </Typography.Text>
          </div>
          <Form.Item
            label={t('站点名称')}
            name="siteName"
            validateFirst
            rules={[
              { max: 50, message: t('站点名称最多为50字'), validateTrigger: 'onChange' },
              {
                validator: (_, val, callback) => {
                  if (val?.length > 0) {
                    checkedSiteName(val, id).then(res => {
                      if (res) {
                        callback()
                        // return Promise.resolve()
                      } else {
                        callback(t('站点名称已存在'))
                      }
                    })
                  } else {
                    callback()
                  }
                },
                validateTrigger: 'onSubmit',
              },
            ]}
          >
            <Input style={{ width: 362 }} placeholder={t('请输入站点名称')} />
          </Form.Item>
          <div className="main-title" style={{ marginTop: 20 }}>
            {t('基础配置')}
          </div>
          <Form.Item
            name="areaId"
            label={t('安全域')}
            style={{ paddingLeft: 4 }}
            rules={[{ required: true }]}
          >
            <Select placeholder={t('请选择安全域')} loading={siteLoading} style={{ width: 360 }}>
              {siteArea?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className="web-auth">
            <div className="web-label" style={{ marginRight: '56px' }}>
              {t('Web认证')}
            </div>
            <Form.Item name={'authMode'} rules={[{ required: true }]}>
              <Radio.Group
                value={method}
                onChange={e => {
                  setMethod(e.target.value)
                  if (e.target.value === 'AuthModeCookieAuth') {
                    setCookieSwitch(true)
                    form.setFieldValue('cookieAuth', '')
                    form.setFieldValue('cookieRefreshType', 'payload_frequency')
                  }
                }}
              >
                <Radio value="AuthModeNo" style={{ marginRight: '32px' }}>
                  {t('无认证')}
                </Radio>
                <Radio value="AuthModeProtocolAuth" style={{ marginRight: '32px' }}>
                  {t('协议认证')}
                </Radio>
                <Radio value="AuthModeCookieAuth" style={{ marginRight: '32px' }}>
                  {t('Cookies认证')}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <AuthBox style={{ paddingLeft: 4 }}>
            {method === 'AuthModeProtocolAuth' && (
              <>
                <Form.Item
                  label={t('用户名')}
                  name="username"
                  rules={[{ required: true }, { max: 128, message: t('用户名最多为128位') }]}
                >
                  <Input placeholder={t('请输入用户名')} style={{ width: 360 }} />
                </Form.Item>
                <Form.Item
                  label={t('密码')}
                  name="password"
                  rules={[{ required: true }, { max: 32, message: t('密码最多为32位') }]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={t('请输入密码')}
                    style={{ width: 360 }}
                  />
                </Form.Item>
              </>
            )}
            {method === 'AuthModeCookieAuth' && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                  <span>{t('动态获取cookie开关：')}</span>
                  <Switch
                    checked={cookieSwitch}
                    checkedChildren={t('开')}
                    unCheckedChildren={t('关')}
                    onChange={e => {
                      setCookieSwitch(e)
                      form.setFieldValue('cookieRefreshType', 'payload_frequency')
                    }}
                  />
                </div>
                {cookieSwitch && (
                  <>
                    <Form.Item
                      label={t('动态获取频率')}
                      name="cookieRefreshType"
                      rules={[{ required: true }]}
                      className="form-item-cookie-refresh"
                    >
                      <Radio.Group
                        onChange={val => {
                          setCookieType(val.target.value)
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', height: '32px' }}>
                          <Radio value="payload_frequency">
                            {t('payload 频率')}{' '}
                            <Tooltip
                              getPopupContainer={() => document.body}
                              title={t('在每次发送payload前自动更新Cookie')}
                            >
                              <IconFont type="icon-tishi" style={{ color: '#909090' }} />
                            </Tooltip>
                          </Radio>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Radio
                            value="customizable_frequency"
                            style={{
                              width: '90px',
                            }}
                          >
                            {t('指定频率')}
                          </Radio>
                        </div>
                        {cookieType === 'customizable_frequency' && (
                          <div className="form-item-cookie-refresh-seconds-box">
                            <Form.Item
                              label=""
                              style={{ width: '180px' }}
                              className="form-item-cookie-refresh-seconds"
                            >
                              <Form.Item
                                name="cookieRefreshSeconds"
                                rules={[{ required: true, message: t('请输入频率') }]}
                                noStyle
                              >
                                <InputNumber
                                  style={{ width: '320px' }}
                                  min={1}
                                  max={60}
                                  precision={0}
                                  placeholder={t('请输入频率')}
                                />
                              </Form.Item>
                              <span className="unit">
                                {t('秒')}
                                <Tooltip
                                  getPopupContainer={() => document.body}
                                  title={t('发送payload前检测历史cookie是否过期，过期后再次获取')}
                                >
                                  <IconFont
                                    type="icon-tishi"
                                    style={{ color: '#909090', marginLeft: '5px' }}
                                  />
                                </Tooltip>
                              </span>
                            </Form.Item>
                          </div>
                        )}
                      </Radio.Group>
                    </Form.Item>
                  </>
                )}
                {!cookieSwitch && (
                  <Form.Item label="Cookie" name="cookieAuth" rules={[{ required: true }]}>
                    <Input placeholder={t('请输入')} style={{ width: '356px' }} />
                  </Form.Item>
                )}
              </>
            )}
          </AuthBox>
          <Form.Item
            name="deviceIdList"
            label={t('关联安全设备')}
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <Cascader
              multiple
              maxTagCount="responsive"
              allowClear
              fieldNames={{
                label: 'name',
                value: 'device_id',
                children: 'device_list',
              }}
              style={{ width: '360px' }}
              options={preDeviceListData(deviceData)}
              onChange={onDeviceSelectChange}
              placeholder={t('请选择安全设备')}
              showCheckedStrategy={SHOW_CHILD}
            />
          </Form.Item>
          <Form.Item
            name="defaultVerifyDevice"
            label={t('验证默认设备')}
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <Cascader
              multiple
              maxTagCount="responsive"
              allowClear
              fieldNames={{
                label: 'name',
                value: 'device_id',
                children: 'device_list',
              }}
              style={{ width: '360px' }}
              options={preVerifyDeviceListData(deviceData, selectedDevices)}
              onChange={(value, selectedOptions) => {
                // 1. 获取所有可选 device_id
                const enabledDeviceIds: string[] = []
                preVerifyDeviceListData(deviceData, selectedDevices).forEach(group => {
                  group.device_list?.forEach(device => {
                    if (!device.disabled) {
                      enabledDeviceIds.push(device.device_id)
                    }
                  })
                })

                // 2. 过滤 value，只保留可选的 device_id
                const filteredValue = value.filter((v: any[]) => enabledDeviceIds.includes(v[1]))

                // 3. 设置过滤后的值
                form.setFieldValue('defaultVerifyDevice', filteredValue)

                // 4. 你原有的逻辑
                onDeviceSelect(filteredValue, selectedOptions)
              }}
              placeholder={t('请选择验证默认设备')}
              showCheckedStrategy={SHOW_CHILD}
            />
          </Form.Item>
          <Form.Item
            name="wafDetectSwitch"
            label={t('WAF防护检测开关')}
            valuePropName="checked"
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <BasSwitch />
          </Form.Item>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 4,
            }}
          >
            <div className="main-title">{t('指纹信息')}</div>
          </div>
          {originFrom === 'OriginFromCollection' && (
            <div className="auto-update-firm">
              <Form.Item label={t('实时更新')} name="autoUpdateFirm" valuePropName="checked">
                <BasSwitch />
              </Form.Item>
            </div>
          )}
          <Form.Item label={t('操作系统')} name={'os'} style={{ paddingLeft: 4, marginBottom: 24 }}>
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.osList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label={t('数据库')} name={'db'} style={{ paddingLeft: 4, marginBottom: 24 }}>
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.dbList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={t('开发语言')}
            name={'language'}
            style={{ paddingLeft: 4, marginBottom: 20 }}
          >
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.languageList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <ComponentBox>
            <div style={{ marginTop: 40, width: 130 }}>{t('影响组件')}</div>
            <div className="component-box">
              <div className="filter-box">
                <Form.Item
                  name="componentSwitch"
                  style={{ paddingLeft: 20 }}
                  className="filter"
                  valuePropName="checked"
                >
                  <Checkbox value={2}>{t('用例过滤')}</Checkbox>
                </Form.Item>
                <Tooltip
                  title={t('勾选后系统将会按选择影响组件进行执行用例过滤')}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <SvgIcon
                    name={t('提示')}
                    style={{ width: '14px', height: '14px', marginTop: 2 }}
                  />
                </Tooltip>
              </div>
              <Form.Item
                name={'component'}
                style={{ width: 360, paddingLeft: 4 }}
                className="component"
              >
                <Select
                  placeholder={t('请选择影响组件')}
                  loading={fingerprintLoading}
                  mode="multiple"
                  allowClear
                  showSearch
                  showArrow
                  optionFilterProp="name"
                  maxTagCount={4}
                  maxTagTextLength={4}
                  defaultValue={[]}
                  onChange={(e: any, keys) => {
                    setComponentId(keys?.map(it => it.value))
                    e.some(groups => {
                      if (groups === '-1') {
                        const arr = []
                        newComponentList
                          ?.filter(item => item.id !== '-1')
                          ?.map(item => arr.push(item.id))
                        arr.push('-1')
                        form.setFieldsValue({
                          component: arr,
                        })
                        setComponentId(arr.slice(0))
                        return
                      }
                      if (groups !== '-1' && e.length === newComponentList.length - 1) {
                        const arr = []
                        newComponentList
                          ?.filter(item => item.id !== '-1')
                          ?.map(item => arr.push(item.id))
                        arr.push('-1')
                        form.setFieldsValue({
                          component: arr,
                        })
                        setComponentId(arr.slice(0))
                        return
                      }
                      setComponentId(e)
                    })
                  }}
                  onDeselect={e => {
                    if (form.getFieldValue('component').length === newComponentList.length) {
                      let arr = []
                      form.getFieldValue('component').map((item, i) => {
                        if (item !== e && item !== '-1') {
                          arr.push(item)
                        }
                      })
                      form.setFieldsValue({
                        component: arr,
                      })
                      setComponentId(arr)
                    }
                    if (e === '-1') {
                      form.setFieldsValue({
                        component: [],
                      })
                      setComponentId([])
                    }
                  }}
                >
                  {newComponentList?.map(item => (
                    <Option name={item.name} value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </ComponentBox>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              color: '#333',
              lineHeight: '21px',
              marginBottom: 20,
            }}
          >
            {t('攻击用例发送规则')}
          </div>
          <div style={{ marginBottom: 20, color: '#666' }}>
            {t('发送规则：')}
            <span>{t('默认发送操作系统、数据库、开发语言、影响组件对应配置的攻击用例')}</span>
          </div>
          <div className="main-title">{t('其它')}</div>
          <Form.Item name="remark" label={t('备注')} style={{ marginTop: 20, marginBottom: 0 }}>
            <TextArea
              rows={4}
              placeholder={t('请输入（100字）')}
              style={{ width: 710 }}
              maxLength={100}
            />
          </Form.Item>
        </ContentBox>
      </Form>
    </DrawerBox>
  )
}

export default EditSiteModal

const DrawerBox = styled(Drawer)`
  .ant-drawer-close {
    width: 36px;
    height: 36px;
    background: #d8d6f4;
    box-shadow: -1px 4px 10px 0px #c7c7c7;
    border-radius: 6px;
    border: none;
    margin-right: 0px;
    color: #4238c9;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translate(-10px, 8px);
      box-shadow: 0 0 0 0;
    }

    .ant-drawer-close-x {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }
  .ant-drawer-header {
    height: 56px;
    background: #f2f0ff;
    border-bottom: none;
    margin: 0;
  }
`

const Description = styled.div`
  display: inline-block;
  font-size: 12px;
  color: #999999;
  margin-bottom: 22px;
`
const ContentBox = styled.div`
  .main-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    line-height: 21px;
    margin-bottom: 20px;
  }
  .ant-form-item-label {
    width: 130px;
    text-align: left;
  }
  .web-auth {
    display: flex;
    align-items: center;
    padding-left: 4px;
    flex-direction: row;
    .web-label {
      margin-right: 16px;

      &::before {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }
    .ant-form-item {
      margin-bottom: 0;
    }
    margin-bottom: 14px;
    margin-top: 24px;
  }
`
const ComponentBox = styled.div`
  display: flex;
  .title-box {
    margin-left: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    width: 356px;
    justify-content: space-between;
  }
  .component-box {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
  .filter-box {
    display: flex;
    align-items: center;
  }
  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
  }
  .filter {
    width: 108px;
    margin-bottom: 0;
  }
`
const DeviceContainer = styled.div`
  background: #f8f9fb;
  //background: #FEF2F2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 30px;
  padding-left: 12px;
  padding-right: 26px;
  border-radius: 8px;
  margin-bottom: 10px;
  .flex {
    display: flex;
  }
  .title {
    width: 70px;
    color: #86909c;
    margin-right: 6px;
  }
  .value {
    width: 100px;
  }
  .value1 {
    width: 200px;
  }
`
const BasId = styled.div`
  margin-bottom: 20px;
  .ant-form-item-row {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-start;
    .ant-form-item-label {
      padding: 0;
    }
    .ant-form-item-control {
      width: auto;
    }
  }
`
const AuthBox = styled.div`
  .form-item-cookie-refresh {
    margin-bottom: 15px;
    .ant-form-item-label {
      padding-bottom: 0;
      margin-right: 10px;
    }
    .ant-form-item-row {
      height: 32px;
      display: flex;
      flex-direction: row;
      align-items: baseline;
      .ant-form-item-control {
        width: auto;
        #cookieRefreshType {
          display: flex;
          flex-direction: row;
          align-items: baseline;
        }
      }
    }
  }
  .form-item-cookie-refresh-seconds-box {
    display: flex;
    align-items: baseline;
    .form-item-cookie-refresh-seconds {
      margin-bottom: 0;
      margin-right: 10px;
      .ant-form-item-control-input-content {
        display: flex;
        align-items: center;
        .unit {
          margin-left: 10px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
`
